import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { StepRouter } from './stepRouter.component';
import { BookingActions, selectBookingStep } from '../../../modules/booking';
import { selectCurrentExperienceHomeRoute } from '../../../modules/experience';

const mapStateToProps = createStructuredSelector({
  step: selectBookingStep,
  experienceUrl: selectCurrentExperienceHomeRoute,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      nextStep: BookingActions.requestNextStep,
      prevStep: BookingActions.previousStep,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(StepRouter);
